/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleADownIcon16Regular = forwardRef('ArrowShapeTriangleADownIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.841 4a1.25 1.25 0 0 1 1.056 1.919l-3.841 6.065a1.25 1.25 0 0 1-2.112 0L3.102 5.92A1.25 1.25 0 0 1 4.158 4h7.683Zm-.454 1.5H4.613L8 10.848 11.387 5.5Z" })));
});
